import type { Locale } from '@change-corgi/config/locales';
import { isSupportedLocale } from '@change-corgi/config/locales';

import { useTopicPageData } from 'src/app/pages/topic/pageContext';

type Result = ModelHookResult<{
	image: string;
	title: string;
	slug: string;
	lang: string | false;
}>;

function upperCaseFirstChar(s: string) {
	return s.charAt(0).toUpperCase() + s.substring(1).toLowerCase();
}

function extractLang(slug: string): string | false {
	const regex: RegExp = /-([a-z]{2})-([a-z]{2})$/i;
	const match = slug.match(regex);

	if (match) {
		const lang = `${match[1].toLowerCase()}-${match[2].toUpperCase()}`;

		if (isSupportedLocale(lang as Locale)) {
			return lang;
		}
	}

	return false;
}

export function usePageMeta(): Result {
	const {
		data: { name, photos, slug },
	} = useTopicPageData();

	const lang = extractLang(slug);

	const title = upperCaseFirstChar(name);

	return {
		data: {
			image: photos[0]?.heroMedium.url ?? 'https://static.change.org/images/default-petition.gif',
			title,
			lang,
			slug,
		},
	};
}
